import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // Import your custom CSS file
import { ClientIdProvider } from "./authContext/ClientIdContext";
import { AuthContextProvider } from "./authContext/AuthContext";
import { SnackbarProvider } from "notistack";
import { StoreProvider } from "./authContext/StoreContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClientIdProvider>
      <AuthContextProvider>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
        >
          <StoreProvider>
            <App />
          </StoreProvider>
        </SnackbarProvider>
      </AuthContextProvider>
    </ClientIdProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
